var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseButton({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.04264 30C1.64747 30 1.2523 29.8497 0.952057 29.5472C0.349314 28.9444 0.349314 27.9673 0.952057 27.3645L27.8645 0.452057C28.4673 -0.150686 29.4444 -0.150686 30.0472 0.452057C30.6499 1.0548 30.6499 2.032 30.0472 2.63511L3.13511 29.5472C2.83261 29.8478 2.43744 30 2.04264 30Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.957 30C28.5618 30 28.167 29.8497 27.8664 29.5472L0.952057 2.63511C0.349314 2.032 0.349314 1.0548 0.952057 0.452057C1.5548 -0.150686 2.532 -0.150686 3.13511 0.452057L30.0472 27.3645C30.6499 27.9673 30.6499 28.9444 30.0472 29.5472C29.7447 29.8478 29.3499 30 28.957 30Z",
    fill: "currentColor"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMSAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBvcGFjaXR5PSIwLjYiPgogICAgPHBhdGgKICAgICAgZD0iTTIuMDQyNjQgMzBDMS42NDc0NyAzMCAxLjI1MjMgMjkuODQ5NyAwLjk1MjA1NyAyOS41NDcyQzAuMzQ5MzE0IDI4Ljk0NDQgMC4zNDkzMTQgMjcuOTY3MyAwLjk1MjA1NyAyNy4zNjQ1TDI3Ljg2NDUgMC40NTIwNTdDMjguNDY3MyAtMC4xNTA2ODYgMjkuNDQ0NCAtMC4xNTA2ODYgMzAuMDQ3MiAwLjQ1MjA1N0MzMC42NDk5IDEuMDU0OCAzMC42NDk5IDIuMDMyIDMwLjA0NzIgMi42MzUxMUwzLjEzNTExIDI5LjU0NzJDMi44MzI2MSAyOS44NDc4IDIuNDM3NDQgMzAgMi4wNDI2NCAzMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogICAgPHBhdGgKICAgICAgZD0iTTI4Ljk1NyAzMEMyOC41NjE4IDMwIDI4LjE2NyAyOS44NDk3IDI3Ljg2NjQgMjkuNTQ3MkwwLjk1MjA1NyAyLjYzNTExQzAuMzQ5MzE0IDIuMDMyIDAuMzQ5MzE0IDEuMDU0OCAwLjk1MjA1NyAwLjQ1MjA1N0MxLjU1NDggLTAuMTUwNjg2IDIuNTMyIC0wLjE1MDY4NiAzLjEzNTExIDAuNDUyMDU3TDMwLjA0NzIgMjcuMzY0NUMzMC42NDk5IDI3Ljk2NzMgMzAuNjQ5OSAyOC45NDQ0IDMwLjA0NzIgMjkuNTQ3MkMyOS43NDQ3IDI5Ljg0NzggMjkuMzQ5OSAzMCAyOC45NTcgMzBaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgCloseButton as ReactComponent };